import React, { useContext, useEffect, useRef, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import TransferTicketModal from "../TransferTicketModal";
import toastError from "../../errors/toastError";
import { Can } from "../Can";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Grow, ListSubheader, Slide, useMediaQuery } from "@material-ui/core";
import { messengerText as text } from "../../translate/messenger";

const TicketOptionsMenu = ({ ticket, menuOpen, handleClose, anchorEl, statusActions }) => {
	const mobile = useMediaQuery("(max-width:599.95px)");
	const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
	const isMounted = useRef(true);
	const { user } = useContext(AuthContext);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const handleDeleteTicket = async () => {
		try {
			await api.delete(`/tickets/${ticket.id}`);
		} catch (err) {
			toastError(err);
		}
	};

	const handleOpenConfirmationModal = () => {
		setConfirmationOpen(true);
		handleClose();
	};

	const handleOpenTransferModal = () => {
		setTransferTicketModalOpen(true);
		handleClose();
	};

	const handleCloseTransferTicketModal = () => {
		if (isMounted.current) {
			setTransferTicketModalOpen(false);
		}
	};

	return (
		<>
			<Menu
				TransitionComponent={mobile ? Slide : Grow}
				transitionDuration={reduceMotion ? 0 : 220}
				TransitionProps={mobile ? { direction: "up" } : {}}
				BackdropProps={{ invisible: !mobile }}
				PaperProps={{ className: mobile ? "tw-fixed tw-inset-x-0 tw-bottom-0 tw-top-auto tw-m-0 tw-max-h-[85dvh] tw-w-full tw-max-w-none tw-rounded-t-3xl tw-p-3 tw-pb-[max(16px,env(safe-area-inset-bottom))]" : "tw-min-w-[260px] tw-rounded-2xl tw-p-2" }}
				MenuListProps={{ "aria-label": text("actions") }}
				id="menu-appbar"
				anchorEl={anchorEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				keepMounted
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				open={menuOpen}
				onClose={handleClose}
			>
				{mobile && <ListSubheader disableSticky className="tw-bg-transparent tw-text-base tw-font-semibold tw-text-inherit">{text("actions")}</ListSubheader>}
				{statusActions}
				{ticket.status === "open" && <MenuItem onClick={handleOpenTransferModal} className="tw-min-h-[48px]">
					{i18n.t("ticketOptionsMenu.transfer")}
				</MenuItem>}
				{ticket.status === "open" && <Can
					role={user.profile}
					perform="ticket-options:deleteTicket"
					yes={() => (
						<MenuItem onClick={handleOpenConfirmationModal} className="tw-min-h-[48px] tw-text-red-600">
							{i18n.t("ticketOptionsMenu.delete")}
						</MenuItem>
					)}
				/>}
				{mobile && <MenuItem onClick={handleClose} className="tw-min-h-[48px]">{text("close")}</MenuItem>}
			</Menu>
			<ConfirmationModal
				title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")}${
					ticket.id
				} ${i18n.t("ticketOptionsMenu.confirmationModal.titleFrom")} ${
					ticket.contact.name
				}?`}
				open={confirmationOpen}
				onClose={setConfirmationOpen}
				onConfirm={handleDeleteTicket}
			>
				{i18n.t("ticketOptionsMenu.confirmationModal.message")}
			</ConfirmationModal>
			<TransferTicketModal
				modalOpen={transferTicketModalOpen}
				onClose={handleCloseTransferTicketModal}
				ticketid={ticket.id}
				ticketWhatsappId={ticket.whatsappId}
			/>
		</>
	);
};

export default TicketOptionsMenu;
